import {
  getAsset,
  getLabel,
  shouldShowSponsorship,
} from "../../../utils/appConfig";
import filterIcon from "../../../assets/images/filter.svg";
import { useNavigate } from "react-router-dom";
import useStore from "../../../store/useStore";

export default function Header() {
  const navigate = useNavigate();
  const { planDetails } = useStore();
  const { shot_plan, isSelfShotsPlan } = planDetails || {};
  const { service_payer } = shot_plan || {};
  // Get the appropriate logo based on app configuration
  const shotsLogo = getAsset("shots");
  const shotsLabel = getLabel("shotsLabel");
  // Check if we should show sponsorship information
  const showSponsorship = shouldShowSponsorship();

  return (
    <div className="sticky top-0 bg-white p-4 z-10">
      <div className="flex items-center justify-between">
        <div className="flex flex-col items-center">
          <img
            src={shotsLogo}
            alt={shotsLabel}
            className="h-[38px]"
            loading="lazy"
          />
          {showSponsorship && !isSelfShotsPlan && service_payer?.containerName && (
            <div className="flex items-center text-center font-normal leading-[17px] text-[8px]">
              <div className="self-stretch my-auto">Sponsored By</div>
              <img
                loading="lazy"
                src={service_payer?.containerName}
                className="h-[25px] w-auto object-contain ml-1"
              />
            </div>
          )}
        </div>
        {/* <img src={filterIcon} onClick={() => navigate("/preferences")} /> */}
      </div>
    </div>
  );
}
